export const mutations = {
  OBS_EXPERIENCE: "OBS_EXPERIENCE",
  OBS_DESCRIBES: "OBS_DESCRIBES",
  OBS_PRIMARYGOAL: "OBS_PRIMARYGOAL",
  OBS_SUBSCRIBE: "OBS_SUBSCRIBE",
  OBS_RECUSE_DATA: "OBS_RECUSE_DATA",
  OBS_UPDATE_STATUS: "OBS_UPDATE_STATUS",
};

export const actions = {
  OBS_SUBMIT_SURVEYINFO: "obsSubmitSurveyinfo",
};
